import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    this.hidden = this.dismissed
  }

  hide() {
    this.hidden = true
  }

  dismiss() {
    this.hidden = true
    this.dismissed = true
  }

  get hidden() {
    return this.element.hidden
  }

  set hidden(value) {
    this.element.hidden = value
  }

  get dismissed() {
    return localStorage.getItem(this.dismissedKey)
  }

  set dismissed(value) {
    localStorage.setItem(this.dismissedKey, value)
  }

  get dismissedKey() {
    return `${this.element.id}:dismissed`
  }
}
